import React, { Component, PropTypes } from 'react';
import Video from 'components/media/Video'; //clearly only exists on Frankly servers

//All this does is adapt videojs style props to the wNVideoCanvasProps nonse, because frankly built their thing to be backward-comaptible
//Their video player can't recieve props, it has to be torn down for updates

class FranklyVideoPlayerAdapter extends Component {
  constructor(props) {
    super(props);

    this.state = {
      videoPlayer: null
    }
  }

  propsAdapter(props){
    try{
      if(!props.sources || !props.sources.length)
         return false
      let mobileStreams = []
      mobileStreams = props.sources.map(function(s){
        return {url: s.src,
                type: s.type}
      })


      let franklyProps = {
        clipId: 1,
        autoPlay: !!props.autoPlay,
        wNVideoCanvasProps: [{
          SetFlashLiveStream: [{
            strUrl: mobileStreams[0].url || '',
            strHeadline: '',
            strAdTag: props.contentClass ,
            hasPreroll: !!props.contentClass,
            strSummaryImageUrl: props.poster || '',
            mobileStreams: mobileStreams
          }]
        }]
      }
      return franklyProps
    } catch(e){
      console.log('propsAdapter has crashed in FranklyVideoPlayerAdapter',e)
      return false
    }
  }

  componentDidMount(){
    let franklyProps = this.propsAdapter(this.props)
    if(!franklyProps)
      return
    this.setState({videoPlayer: <Video {...franklyProps} />})
  }

  componentWillReceiveProps(nextProps){
    let franklyProps = this.propsAdapter(nextProps)
    if(!franklyProps)
      return
    this.setState({videoPlayer: null},()=>{
      this.setState({videoPlayer:  <Video {...franklyProps } />})
    })
  }



  render(){ //note we aren't running this in our gnm- namespace!
      return (
        <div className='frankly-video-player-adapter'>
          {this.state.videoPlayer}
        </div>
      );

  }
}

export default FranklyVideoPlayerAdapter;



// WEBPACK FOOTER //
// ./app/components/custom/ssr/FranklyVideoPlayerAdapter.js